import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import AccountDetails from './components/account-details/AccountDetails';
import ChangePassword from './components/change-password/ChangePassword';
import PrimaryBtn from '../../components/btns/primary-btn/PrimaryBtn';
import ActionField from '../../components/action-field/ActionField';
import InputBar from '../../components/input-bar/InputBar';

// hooks
import { useDeleteAccount } from '../../hooks/useDeleteAccount';

// styles
import {
  AccountPageContainer,
  AccountContent,
  DualColumnContainer
} from './AccountPage.styles.js';
import { InputContainer } from './components/account-details/AccountDetails.styles.js';

export default function AccountPage() {
  const navigate = useNavigate();
  const [confirmationStep, setConfirmationStep] = useState(0);
  const [currentPassword, setCurrentPassword] = useState('');
  const { deleteAccount, isPending } = useDeleteAccount();

  const handleDeleteAccount = async () => {
    if (confirmationStep === 0) {
      setConfirmationStep(1);
      return;
    }

    // confirmationStep === 1 → execute deletion
    const result = await deleteAccount(currentPassword);
    if (result.success) {
      navigate('/');
    } else {
      alert(`Failed to delete account: ${result.error}`);
      setConfirmationStep(0);
      setCurrentPassword('');
    }
  };

  const handleCancelDelete = () => {
    setConfirmationStep(0);
    setCurrentPassword('');
  };

  const getDeleteButtonTitle = () => {
    switch (confirmationStep) {
      case 1:
        return 'DELETE ACCOUNT FOREVER (CANNOT BE UNDONE)';
      default:
        return 'DELETE ACCOUNT';
    }
  };

  return (
    <AccountPageContainer>
      <AccountContent className='widget-bg'>
        <h1>ACCOUNT</h1>
        <DualColumnContainer>
          <AccountDetails />
          <ChangePassword />
        </DualColumnContainer>
        <div className='horizontal-divider' />
        {confirmationStep === 1 && (
          <ActionField>
            <InputContainer>
              <InputBar 
                label={"Current Password"} 
                type={'password'} 
                value={currentPassword} 
                updateValue={setCurrentPassword} 
                placeholder="Enter your current password to confirm deletion"
                showPasswordToggle
              />
            </InputContainer>
          </ActionField>
        )}
        <PrimaryBtn
          type='critical'
          title={getDeleteButtonTitle()}
          onClick={handleDeleteAccount}
          disabled={(confirmationStep === 1 && currentPassword.length === 0) || isPending}
          isLoading={isPending}
          width={'hug'}
        />
        {confirmationStep > 0 && (
          <PrimaryBtn
            type='default'
            title='CANCEL'
            onClick={handleCancelDelete}
            disabled={isPending}
          />
        )}
      </AccountContent>
    </AccountPageContainer>
  );
}